import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useModalDialog } from '~/composables';
import UiLink from '~/components/ui/UiLink.vue';

interface Props {
  variant?: string;
  innerWrapperClass?: string;
  inverted?: boolean;
  size?: string;
  minWidth?: string;
  outlined?: boolean;
  flat?: boolean;
  icon?: string | null;
  loading?: boolean;
  type?: string | null;
  to?: string | null;
  target?: string | null;
  block?: boolean;
  fitHeight?: boolean;
  disabled?: boolean;
  absolute?: boolean;
  rounded?: boolean;
  modal?: string;
}
interface Emits {
  (e: 'click'): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UiButton',
  props: {
    variant: { default: 'primary' },
    innerWrapperClass: { default: '' },
    inverted: { type: Boolean, default: false },
    size: { default: 'sm' },
    minWidth: { default: undefined },
    outlined: { type: Boolean, default: true },
    flat: { type: Boolean, default: false },
    icon: { default: null },
    loading: { type: Boolean, default: false },
    type: { default: null },
    to: { default: null },
    target: { default: null },
    block: { type: Boolean, default: false },
    fitHeight: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    absolute: { type: Boolean, default: false },
    rounded: { type: Boolean, default: true },
    modal: { default: undefined }
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'click'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { variant: string, innerWrapperClass: string, inverted: boolean, size: string, minWidth: string, outlined: boolean, flat: boolean, icon: string | null, loading: boolean, type: string | null, to: string | null, target: string | null, block: boolean, fitHeight: boolean, disabled: boolean, absolute: boolean, rounded: boolean, modal: string };





const variants: Record<string, any> = {
  primary: {
    base: 'bg-blue border-blue text-white hover:bg-blue-darker1 hover:border-blue-darker1 active:bg-blue-darker2 active:border-blue-darker2',
    inverted:
      'bg-white border-white text-blue hover:text-blue-darker1 hover:bg-gray-lighten5 hover:border-gray-lighten5 active:bg-gray-lighten5 active:border-gray-lighten5 active:text-blue-darker2',
  },
  secondary: {
    base: 'border-blue text-blue hover:border-blue-darker1 hover:text-blue-darker1',
    inverted: 'border-white text-white hover:border-neutral hover:text-neutral',
  },
  joinu: {
    base: 'from-[#555DE8] to-[#1EA4D6] bg-gradient-45 text-white border-transparent hover:from-blue-darker1 hover:to-blue-darker1 active:from-blue-darker2 active:to-blue-darker2',
    inverted:
      'from-cyan-500 to-blue-500 bg-gradient-45 text-white border-transparent hover:from-blue-darker1 hover:to-blue-darker1 active:from-blue-darker2 active:to-blue-darker2',
  },
  text: {
    base: 'text-blue uppercase',
    inverted: '',
  },
};

const fontSizes: Record<string, string> = {
  xs: 'text-xs',
  sm: 'text-sm',
  md: 'text-sm',
  lg: 'text-sm',
};

const sizes: Record<string, string> = {
  xs: 'h-8 px-4',
  sm: 'h-10 px-5',
  md: 'h-12 px-6',
  lg: 'h-16 px-6',
};

const currentVariant = computed(() => [
  variants[props.variant][props.inverted ? 'inverted' : 'base'],
  fontSizes[props.size],
  !props.flat && sizes[props.size],
]);

const clickEvent = () => {
  if (props.modal) useModalDialog(props.modal).open();
  else emit('click');
};

return { __sfc: true,props, emit, variants, fontSizes, sizes, currentVariant, clickEvent, UiLink }
}

})